import React, { useState, useEffect, useRef, useCallback } from 'react'
import {
  Row,
  Col,
  ListGroupItem,
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as MyAPI from '../../../utils/MyAPI'
import ReactTags from 'react-tag-autocomplete'

// ApiTokenManageListItem
const ApiTokenManageListItem = (props) => {

  let [keyEnabled, setKeyEnabled] = useState(true);
  let [memo, setMemo] = useState('')
  let [showEntireKeyFlg, setShowEntireKeyFlg] = useState(false)
  let [memoEditMode, setMemoEditMode] = useState(false)
  let [dispStatus, setDispStatus] = useState("確認中")
  let [showRecreateConf, setShowRecreateConf] = useState(false)

  let [showDetailFlg, setShowDetailFlg] = useState(false)
  let [paramPostAction, setParamPostAction] = useState("")
  let [paramS3Bucket, setParamS3Bucket] = useState("")
  let [paramAwsAccessKeyId, setParamAwsAccessKeyId] = useState("")
  let [paramAwsSecretAccessKey, setParamAwsSecretAccessKey] = useState("")
  let [paramSocketPostUrl, setParamSocketPostUrl] = useState("")
  let [paramSocketPostKey, setParamSocketPostKey] = useState("")
  let [paramSocketPostTimeType, setParamSocketPostTimeType] = useState("")

  const [minusTags, setMinusTags] = useState([])
  const [plusTags, setPlusTags] = useState([])

  const [suggestions, setSuggestions] = useState([])

  const [keywrodTags, setKeywrodTags] = useState([])
  const [keywordSuggestions, setKeywordSuggestions] = useState([])

  // xid decor 
  let [decorLoginUrl, setDecorLoginUrl] = useState("")
  let [decorSystemUserId, setDecorSystemUserId] = useState("")
  let [decorSystemUserPassword, setDecorSystemUserPassword] = useState("")
  let [decorTenantKey, setDecorTenantKey] = useState("")
  let [decorPostUrl, setDecorPostUrl] = useState("")


  const minusTagsRef = useRef()
  const plusTagsRef = useRef()
  const keywordTagsRef = useRef()

  const onDeleteMinus = useCallback((tagIndex) => {
    setMinusTags(minusTags.filter((_, i) => i !== tagIndex))
  }, [minusTags])

  const onDeletePlus = useCallback((tagIndex) => {
    setPlusTags(plusTags.filter((_, i) => i !== tagIndex))
  }, [plusTags])

  const onAdditionMinus = useCallback((newTag) => {

    let _exists = false
    let _minusTags = minusTags
    for (let i=0; i<_minusTags.length; i++) {
      if (_minusTags[i].id === newTag.id) {
        _exists = true
        break
      }
    }

    if (_exists === false) {
      setMinusTags([...minusTags, newTag])
    }

  }, [minusTags])


  const onAdditionPlus = useCallback((newTag) => {

    let _exists = false
    let _plusTags = plusTags
    for (let i=0; i<_plusTags.length; i++) {
      if (_plusTags[i].id === newTag.id) {
        _exists = true
        break
      }
    }

    if (_exists === false) {
      setPlusTags([..._plusTags, newTag])
    }

  }, [plusTags])


  // keywords tracking

  // onAdditionKeywords
  const onAdditionKeywords = useCallback((newTag) => {

    let _exists = false
    let _tags = keywrodTags
    for (let i=0; i<_tags.length; i++) {
      if (_tags[i].id === newTag.id) {
        _exists = true
        break
      }
    }

    if (_exists === false) {
      setKeywrodTags([..._tags, newTag])
    }

  }, [keywrodTags])

  // onDeleteKeywords
  const onDeleteKeywords = useCallback((tagIndex) => {
    setKeywrodTags(keywrodTags.filter((_, i) => i !== tagIndex))
  }, [keywrodTags])


  // componentDidMount
  useEffect(() => {

    if (!props.item) {
      return
    }

    if (props.item.disabled === true) {
      setKeyEnabled(false)
    }
    if (props.item.memo) {
      setMemo(props.item.memo)
    }
    if ( props.item.status === "ready" ) {

      if (props.item.disabled === true) {
        setDispStatus("一時停止中")
      } else {
        setDispStatus("正常")
      }

    } else if (props.item.status === "preparing") {
      setDispStatus("準備中")
    }

    if (props.item.post_action) {
      setParamPostAction(props.item.post_action)
    } else {
      setParamPostAction("")
    }
    if (props.item.s3_bucket) {
      setParamS3Bucket(props.item.s3_bucket)
    } else {
      setParamS3Bucket("")
    }
    if (props.item.aws_access_key_id) {
      setParamAwsAccessKeyId(props.item.aws_access_key_id)
    } else {
      setParamAwsAccessKeyId("")
    }
    if (props.item.aws_secret_access_key) {
      setParamAwsSecretAccessKey(props.item.aws_secret_access_key)
    } else {
      setParamAwsSecretAccessKey("")
    }
    if (props.item.socket_post_url) {
      setParamSocketPostUrl(props.item.socket_post_url)
    } else {
      setParamSocketPostUrl("")
    }
    if (props.item.socket_post_key) {
      setParamSocketPostKey(props.item.socket_post_key)
    } else {
      setParamSocketPostKey("")
    }
    if (props.item.socket_post_time_type) {
      setParamSocketPostTimeType(props.item.socket_post_time_type)
    } else {
      setParamSocketPostTimeType("")
    }

    // dictionary
    if (props.item.minus_dict_tags && props.item.minus_dict_tags.length > 0) {
      setMinusTags(props.item.minus_dict_tags)
    }
    if (props.item.plus_dict_tags && props.item.plus_dict_tags.length > 0) {
      setPlusTags(props.item.plus_dict_tags)
    }
    if (props.item.tracking_dict_tags && props.item.tracking_dict_tags.length > 0) {
      setKeywrodTags(props.item.tracking_dict_tags)
    }

    // xit decor 

    // decor_login_url
    if (props.item.decor_login_url) {
      setDecorLoginUrl(props.item.decor_login_url)
    } else {
      setDecorLoginUrl("")
    }

    // decor_system_user_id
    if (props.item.decor_system_user_id) {
      setDecorSystemUserId(props.item.decor_system_user_id)
    } else {
      setDecorSystemUserId("")
    }

    // decor_system_user_password
    if (props.item.decor_system_user_password) {
      setDecorSystemUserPassword(props.item.decor_system_user_password)
    } else {
      setDecorSystemUserPassword("")
    }

    // decor_tenant_key
    if (props.item.decor_tenant_key) {
      setDecorTenantKey(props.item.decor_tenant_key)
    } else {
      setDecorTenantKey("")
    }

    // decor_post_url
    if (props.item.decor_post_url) {
      setDecorPostUrl(props.item.decor_post_url)
    } else {
      setDecorPostUrl("")
    }


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.item]);

  // shareableDictionaryList
  useEffect(() => {

    if (!props.shareableDictionarySuggestions) {
      return
    }

    setSuggestions(props.shareableDictionarySuggestions)


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.shareableDictionarySuggestions]);

  // tracking keyword suggestions
  useEffect(() => {

    if (!props.shareableTrackingKeywordSuggestions) {
      return
    }

    // console.log("props.shareableTrackingKeywordSuggestions: ", props.shareableTrackingKeywordSuggestions)

    setKeywordSuggestions(props.shareableTrackingKeywordSuggestions)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.shareableTrackingKeywordSuggestions]);

  // toggle key status
  let _toggleKeyStatus = async () => {
    props.toggleKeyStatus({
      token_id: props.item._id,
    })
  }

  let _handleChangeMemo = (e) => {
    setMemo(e.target.value)
  }

  let _updateMemo = () => {

    props.updateMemo({
      token_id: props.item._id,
      memo: memo,
    })

    setMemoEditMode(false)
  }

  // toggle recreate confirm
  let _toggleRecreateConf = () => {
    if (showRecreateConf === true) {
      setShowRecreateConf(false)
    } else {
      setShowRecreateConf(true)
    }
  }

  // _recreate
  let _recreate = () => {
    props.recreateKey(props.item)
    setShowRecreateConf(false)
  }

  // toggle show entire key
  let _toggleShowEntireKey = () => {
    if (showEntireKeyFlg === true) {
      setShowEntireKeyFlg(false)
    } else {
      setShowEntireKeyFlg(true)
    }
  }

  // toggle memo edit mode
  let _toggleMemoEdit = () => {
    if (memoEditMode === true) {
      setMemoEditMode(false)
    } else {
      setMemoEditMode(true)
    }
  }

  let _copyApiKey = async () => {

    await navigator.clipboard.writeText(props.item.api_key)
    props.showAlert("コピーしました", "info")
  }

  // toggle show detail
  let _toggleShowDetailFlg = () => {

    if (showDetailFlg === true) {
      setShowDetailFlg(false)
    } else {
      setShowDetailFlg(true)
    }
  }

  // _savePostParams
  let _savePostParams = async () => {

    props.setLoading(true)

    try {

      if (!props.login_token) {
        throw Error("login token is not valid")
      }

      if (!paramPostAction) {
        throw Error("please specify post action. supported actions are s3, s3_and_post, wasabi and wassabi_and_post")
      }

      let supported_actions = [
        "s3",
        "s3_and_post",
        "wasabi",
        "wasabi_and_post",
        "s3_and_decor_post",
        "wasabi_and_decor_post",
      ]

      if (supported_actions.indexOf(paramPostAction) === -1) {
        throw Error("only s3, s3_and_post, wasabi and wasabi_and_post are supported now")
      }

      if (paramSocketPostTimeType ) {
        if ( ["int", "float"].indexOf(paramSocketPostTimeType) === -1 ) {
          throw Error("only int or float is supported now")
        }
      }

      // logout on server
      let _results = await MyAPI.updateApiPostParams({
        login_token: props.login_token,
        api_key_id: props.item._id,
        post_action: paramPostAction,
        s3_bucket: paramS3Bucket,
        aws_access_key_id: paramAwsAccessKeyId,
        aws_secret_access_key: paramAwsSecretAccessKey,
        socket_post_url: paramSocketPostUrl,
        socket_post_key: paramSocketPostKey,
        socket_post_time_type: paramSocketPostTimeType,
        decor_login_url: decorLoginUrl,
        decor_system_user_id: decorSystemUserId,
        decor_system_user_password: decorSystemUserPassword,
        decor_tenant_key: decorTenantKey,
        decor_post_url: decorPostUrl,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      // setDeepSpeechTokens(_results.list1)
      props.showAlert("保存しました", "success")

    } catch (err) {
      console.log("err: ", err)

      props.showAlert(err.message, "error")
    }
    props.setLoading(false)
  }


  // _showGenerateNewDicionaryModal
  let _showGenerateNewDicionaryModal = () => {
    props.showGenerateNewDicionaryModal(props.item._id)
  }

  // _saveDictionaryParams
  let _saveDictionaryParams = async () => {

    props.setLoading(true)

    try {

      if (!props.login_token) {
        throw Error("login token is not valid")
      }

      // logout on server
      let _results = await MyAPI.saveDictionaryParams({
        login_token: props.login_token,
        api_key_id: props.item._id,
        minusTags_str: JSON.stringify(minusTags),
        plusTags_str: JSON.stringify(plusTags),
        trackingKeywordTags_str: JSON.stringify(keywrodTags),
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      // setDeepSpeechTokens(_results.list1)
      props.showAlert("保存しました", "success")

    } catch (err) {
      console.log("err: ", err)

      props.showAlert(err.message, "error")
    }
    props.setLoading(false)
  }

  return (

    <ListGroupItem style={{
      // backgroundColor: props.idx % 2 === 0 ? '#ffffff' : '#efefef',
    }}>

      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col md="6" xs="12" style={{
          textAlign: 'left',
          fontSize: 12,
        }}>
          <span style={{
            paddingTop: 4,
            paddingBottom: 4,
            paddingLeft: 8,
            paddingRight: 8,
            backgroundColor: props.item.disabled === true ? '#777777' : '#19795D',
            color: '#ffffff',
          }}>
            createdAt: {props.item.createdAt} / {dispStatus}
          </span>
        </Col>
        <Col md="6" xs="12" style={{
          textAlign: 'right',
          fontSize: 12,
        }}>
          <Button
            onClick={_toggleRecreateConf}
            color="primary"
            style={{
              cursor: 'pointer',
            }}>
            API KEYの再作成
          </Button>
        </Col>
      </Row>

      {showRecreateConf === true && (
        <div style={{
          marginTop: 30,
          marginBottom: 30,
        }}>
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="12" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>
              API KEYを再作成します。今のキーは使えなくなります。キーの再発行を行いますか？
            </Col>
          </Row>
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>
              <Button
                onClick={_toggleRecreateConf}
                color="secondary"
                style={{
                  cursor: 'pointer',
                }}>
                やっぱり止める
              </Button>
            </Col>
            <Col md="6" xs="12" style={{
              textAlign: 'right',
              fontSize: 20,
            }}>
              <Button
                onClick={_recreate}
                color="danger"
                style={{
                  cursor: 'pointer',
                }}>
                キーの再作成を実行する
              </Button>
            </Col>
          </Row>
        </div>
      )}


      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col md="10" xs="12" style={{
          textAlign: 'left',
          fontSize: 20,
        }}>
          <span style={{
            backgroundColor: '#cccccc',
            borderRadius: 4,
            padding: 4,
            fontSize: 16,
            marginRight: 5,
          }}>API URL</span>
          <span>
            {props.item.api_url}
          </span>
        </Col>
        <Col md="2" xs="12">
          {props.item.status === "ready" && (
            <>
              <FontAwesomeIcon
                onClick={_toggleKeyStatus}
                icon={props.item.disabled !== true ? "toggle-on" : "toggle-off"}
                style={{
                  cursor: 'pointer',
                  marginRight: 6,
              }}/>
              {props.item.disabled !== true ? (
                <span>
                  稼働中
                </span>
              ) : (
                <span>
                  停止中
                </span>
              )}
            </>
          )}
        </Col>
      </Row>
      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col md="10" xs="12" style={{
          textAlign: 'left',
          fontSize: 20,
        }}>
          <span style={{
            backgroundColor: '#cccccc',
            borderRadius: 4,
            padding: 4,
            fontSize: 16,
            marginRight: 5,
          }}>API KEY</span>
          {showEntireKeyFlg === true ? (
            <span onClick={_copyApiKey} style={{
              cursor: 'pointer',
            }}>
              {props.item.api_key}
            </span>
          ) : (
            <span onClick={_copyApiKey} style={{
              cursor: 'pointer',
            }}>
              {props.item.api_key.substr(0, 32)+"..."}
            </span>
          )}

        </Col>

        <Col md="2" xs="12" style={{
          textAlign: 'left',
          fontSize: 20,
        }}>
          <FontAwesomeIcon
            onClick={_toggleShowEntireKey}
            icon={showEntireKeyFlg === true ? "eye" : "eye-slash"}
            style={{
              marginTop: 8,
              cursor: 'pointer',
              color: '#777777',
          }}/>
        </Col>
      </Row>

      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col md="10" xs="12" style={{
          textAlign: 'left',
          fontSize: 20,
        }}>

          {memoEditMode === false ? (
            <span>
              <span style={{
                backgroundColor: '#cccccc',
                borderRadius: 4,
                padding: 4,
                fontSize: 16,
                marginRight: 5,
              }}>メモ</span>
              <span>
                {memo}
              </span>
            </span>
          ) : (

            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>メモ</InputGroupText>
              </InputGroupAddon>
              <Input
                type="text"
                name='memo'
                onChange={_handleChangeMemo}
                value={memo}
                placeholder='' />
                <InputGroupAddon addonType="append">
                  <Button onClick={_updateMemo} color="primary">保存</Button>
                </InputGroupAddon>
            </InputGroup>

          )}

        </Col>

        <Col md="2" xs="12" style={{
          textAlign: 'left',
          fontSize: 20,
        }}>
          <FontAwesomeIcon
            onClick={_toggleMemoEdit}
            icon="edit"
            style={{
              marginTop: 8,
              cursor: 'pointer',
              color: '#777777',
          }}/>
        </Col>

      </Row>

      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col md="6" xs="12" style={{
          textAlign: 'left',
          fontSize: 20,
        }}>

          <FontAwesomeIcon
            onClick={_toggleShowDetailFlg}
            icon={showDetailFlg === true ? 'compress' : 'expand'}
            style={{
              marginLeft: 2,
              cursor: 'pointer',
              color: '#777777',
          }}/>

        </Col>

        <Col md="6" xs="12" style={{
          textAlign: 'right',
          fontSize: 16,
        }}>

        </Col>
      </Row>

      {showDetailFlg === true && (
        <div style={{
          padding: 20,
          // margin: 20,
          borderStyle: 'solid',
          borderRadius: 4,
          borderColor: '#cccccc',
          borderWidth: 1,
        }}>

          <div style={{
            padding: 20,
          }}>

          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
          <Col md="12" xs="12" style={{
            textAlign: 'left',
            fontSize: 20,

          }}>
            <span style={{
              paddingTop: 4,
              paddingBottom: 4,
              paddingRight: 8,
              paddingLeft: 8,
              color: '#ffffff',
              backgroundColor: '#5C8168',
            }}>
              -- 録音とWebhook --
            </span>
          </Col>
          </Row>

          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>
              <span>
                post_action:
              </span>
            </Col>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>

              <Input
                type="text"
                name='post_action'
                onChange={(e) => setParamPostAction(e.target.value)}
                value={paramPostAction}
                placeholder='' />

            </Col>
          </Row>
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>
              <span>
                s3_bucket:
              </span>
            </Col>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>

              <Input
                type="text"
                name='s3_bucket'
                onChange={(e) => setParamS3Bucket(e.target.value)}
                value={paramS3Bucket}
                placeholder='' />

            </Col>
          </Row>
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>
              <span>
                aws_access_key_id:
              </span>
            </Col>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>

              <Input
                type="text"
                name='aws_access_key_id'
                onChange={(e) => setParamAwsAccessKeyId(e.target.value)}
                value={paramAwsAccessKeyId}
                placeholder='' />

            </Col>
          </Row>
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>
              <span>
                aws_secret_access_key:
              </span>
            </Col>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>

              <Input
                type="password"
                name='aws_secret_access_key'
                onChange={(e) => setParamAwsSecretAccessKey(e.target.value)}
                value={paramAwsSecretAccessKey}
                placeholder='' />

            </Col>
          </Row>
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>
              <span>
                socket_post_url:
              </span>
            </Col>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>

              <Input
                type="text"
                name='socket_post_url'
                onChange={(e) => setParamSocketPostUrl(e.target.value)}
                value={paramSocketPostUrl}
                placeholder='' />

            </Col>
          </Row>
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>
              <span>
                socket_post_key:
              </span>
            </Col>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>

              <Input
                type="text"
                name='socket_post_url'
                onChange={(e) => setParamSocketPostKey(e.target.value)}
                value={paramSocketPostKey}
                placeholder='' />

            </Col>
          </Row>
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>
              <span>
                socket_post_time_type:
              </span>
            </Col>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>

              <Input
                type="text"
                name='socket_post_time_type'
                onChange={(e) => setParamSocketPostTimeType(e.target.value)}
                value={paramSocketPostTimeType}
                placeholder='' />

            </Col>
          </Row>
          
          {/* decor login and post info */}
          
          {/* decor login url */}
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>
              <span>
                decor login url:
              </span>
            </Col>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>

              <Input
                type="text"
                name='decor_login_url'
                onChange={(e) => setDecorLoginUrl(e.target.value)}
                value={decorLoginUrl}
                placeholder='http://crmfair.de-call.center/dapi_v312/api/d/v1/auth/login' />

            </Col>
          </Row>


          {/* decor user id */}
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>
              <span>
                decor system user id:
              </span>
            </Col>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>

              <Input
                type="text"
                name='decor_system_user_id'
                onChange={(e) => setDecorSystemUserId(e.target.value)}
                value={decorSystemUserId}
                placeholder='738' />

            </Col>
          </Row>




          {/* decor user password */}
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>
              <span>
                decor system user password:
              </span>
            </Col>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>

              <Input
                type="text"
                name='decor_system_user_password'
                onChange={(e) => setDecorSystemUserPassword(e.target.value)}
                value={decorSystemUserPassword}
                placeholder='738' />

            </Col>
          </Row>

          {/* decor Tenant Key */}
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>
              <span>
                decor tenant key:
              </span>
            </Col>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>

              <Input
                type="text"
                name='decor_tenant_key'
                onChange={(e) => setDecorTenantKey(e.target.value)}
                value={decorTenantKey}
                placeholder='b2c' />

            </Col>
          </Row>


          {/* decor post endpoint */}
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>
              <span>
                decor post url:
              </span>
            </Col>
            <Col md="6" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>

              <Input
                type="text"
                name='decor_post_url'
                onChange={(e) => setDecorPostUrl(e.target.value)}
                value={decorPostUrl}
                placeholder='http://crmfair.de-call.center/dapi_v312/api/d/v1/voiceText' />

            </Col>
          </Row>







          {/* button */}
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="12" xs="12" style={{
              textAlign: 'right',
              fontSize: 20,
              // backgroundColor: '#29B7B5',
            }}>
              {showDetailFlg === true && (
                <span onClick={_savePostParams} style={{
                  cursor: 'pointer',
                  color: '#ffffff',
                  backgroundColor: '#4B5217',
                  paddingTop: 4,
                  paddingBottom: 4,
                  paddingRight: 6,
                  paddingLeft: 6,
                  borderRadius: 4,
                }}>
                  更新
                </span>
              )}
            </Col>
          </Row>


          {/* dictonary */}
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
          </Row>
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="12" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>
              <span style={{
                paddingTop: 4,
                paddingBottom: 4,
                paddingRight: 8,
                paddingLeft: 8,
                backgroundColor: '#29B7B5',
                color: '#ffffff',
              }}>
                -- 辞書 --
              </span>
            </Col>
          </Row>

          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="4" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>
            <span style={{
              marginRight: 6,
            }}>
              自分の辞書
            </span>

            {props.item.has_shareable_dictionary === true ? (
              <span style={{
                paddingTop: 4,
                paddingBottom: 4,
                paddingLeft: 8,
                paddingRight: 8,
                backgroundColor: '#29B7B5',
                color: '#ffffff',
              }}>
                共有済み
              </span>
            ) : (
              <FontAwesomeIcon
                onClick={_showGenerateNewDicionaryModal}
                icon="share-from-square"
                style={{
                  cursor: 'pointer',
                  marginLeft: 6,
              }}/>
            )}

            </Col>
            <Col md="4" xs="12" style={{
              textAlign: 'center',
              fontSize: 20,
            }}>
              <span>
                +辞書
              </span>
            </Col>
            <Col md="4" xs="12" style={{
              textAlign: 'center',
              fontSize: 20,
            }}>
              <span>
                -辞書
              </span>
            </Col>
          </Row>

          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="4" xs="12" />
            <Col md="4" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>

              <ReactTags
                ref={plusTagsRef}
                tags={plusTags}
                suggestions={suggestions}
                onDelete={onDeletePlus}
                onAddition={onAdditionPlus}
              />

            </Col>
            <Col md="4" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>

              <ReactTags
                ref={minusTagsRef}
                tags={minusTags}
                suggestions={suggestions}
                onDelete={onDeleteMinus}
                onAddition={onAdditionMinus}
              />

            </Col>
          </Row>



          {/* watch keywords */}
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
          </Row>
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="12" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>
              <span style={{
                paddingTop: 4,
                paddingBottom: 4,
                paddingRight: 8,
                paddingLeft: 8,
                backgroundColor: '#29B7B5',
                color: '#ffffff',
              }}>
                -- トラックキーワード --
              </span>
            </Col>
          </Row>

          {/*<Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="4" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>
            <span style={{
              marginRight: 6,
            }}>
              自分の辞書
            </span>

            {props.item.has_shareable_dictionary === true ? (
              <span style={{
                paddingTop: 4,
                paddingBottom: 4,
                paddingLeft: 8,
                paddingRight: 8,
                backgroundColor: '#29B7B5',
                color: '#ffffff',
              }}>
                共有済み
              </span>
            ) : (
              <FontAwesomeIcon
                onClick={_showGenerateNewDicionaryModal}
                icon="share-from-square"
                style={{
                  cursor: 'pointer',
                  marginLeft: 6,
              }}/>
            )}

            </Col>
            <Col md="4" xs="12" style={{
              textAlign: 'center',
              fontSize: 20,
            }}>
              <span>
                +辞書
              </span>
            </Col>
            <Col md="4" xs="12" style={{
              textAlign: 'center',
              fontSize: 20,
            }}>
              <span>
                -辞書
              </span>
            </Col>
          </Row>*/}

          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="4" xs="12" />
            <Col md="8" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>

              <ReactTags
                ref={keywordTagsRef}
                tags={keywrodTags}
                suggestions={keywordSuggestions}
                onDelete={onDeleteKeywords}
                onAddition={onAdditionKeywords}
              />

            </Col>

            {/*<Col md="4" xs="12" style={{
              textAlign: 'left',
              fontSize: 20,
            }}>

              <ReactTags
                ref={minusTagsRef}
                tags={minusTags}
                suggestions={suggestions}
                onDelete={onDeleteMinus}
                onAddition={onAdditionMinus}
              />

            </Col>*/}
          </Row>



          {/* update button */}
          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="12" xs="12" style={{
              textAlign: 'right',
              fontSize: 20,
              // backgroundColor: '#29B7B5',
            }}>
              {showDetailFlg === true && (
                <span onClick={_saveDictionaryParams} style={{
                  cursor: 'pointer',
                  color: '#ffffff',
                  backgroundColor: '#29B7B5',
                  paddingTop: 4,
                  paddingBottom: 4,
                  paddingRight: 6,
                  paddingLeft: 6,
                  borderRadius: 4,
                }}>
                  更新
                </span>
              )}
            </Col>
          </Row>

          </div>
        </div>
      )}


    </ListGroupItem>
  )
}

export default ApiTokenManageListItem
